module.exports = __webpack_public_path__ + "static/img/101409.56c2afb6.png";